export enum UserEntity {
  Practice = 1, // start with one to be able to check with "if" for availibility
  Patient,
}
